'use client'

import * as React from 'react'
import type { CarouselProps, DotProps } from 'react-multi-carousel'
import CarouselComponent from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { tw } from 'utils/classnames'

const CustomDot = ({ onClick, active }: DotProps) => {
  return (
    <div
      onClick={() => {
        if (onClick) {
          onClick()
        }
      }}
      className={tw(
        active ? 'bg-[#6b7280]' : 'bg-[#d1d5db]',
        'h-[10px] w-[10px] cursor-pointer rounded-full',
      )}
    />
  )
}

const defaultResponsiveProps = {
  desktop: {
    breakpoint: { max: 10_000, min: 1280 },
    items: 3,
    partialVisibilityGutter: 60, // this is optional if you are not using partialVisible props
  },
  tablet: {
    breakpoint: { max: 1280, min: 780 },
    items: 3,
    partialVisibilityGutter: 50, // this is optional if you are not using partialVisible props
  },
  mobile: {
    breakpoint: { max: 780, min: 0 },
    items: 2,
    partialVisibilityGutter: 50, // this is optional if you are not using partialVisible props
  },
}

export function Carousel({
  children,
  showDots,
  customDot,
  responsive = defaultResponsiveProps,
  ...rest
}: Omit<CarouselProps, 'responsive'> & { responsive?: CarouselProps['responsive'] }) {
  const renderDots = () => {
    if (showDots && !customDot) {
      return <CustomDot />
    }
    //inject the custom component
    if (showDots && customDot) {
      // oxlint-disable-next-line no-else-return
      return customDot
    } else {
      return undefined
    }
  }

  return (
    <CarouselComponent
      {...rest}
      responsive={responsive}
      showDots={showDots}
      customDot={renderDots()}
    >
      {children}
    </CarouselComponent>
  )
}
